export default __webpack_public_path__ + "media/zurb/img/services/design-insight/design-insight-jacks-51a0ca6de5c79d77c717bdc952aa64ad.png";